import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { EpGridComponent, IEpGridModel, IEpGridState, IEPGridDataResult, EpGridEvent, IEpGridSelectionOptions, IEpComponentEventArg, EpButtonStyle } from '@epicor/kinetic';
declare var $: any;
import { IEpBtCardControlModel, BistrackConfig, CustomerProductPurchaseSearchDateRange, CustomEvents } from 'ep-bt-controls';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { IEpCardModel } from '@epicor/kinetic';
import { FieldAgentClient, GetProductPurchasesByAllCustomersRequest, CustomerProductPurchaseSearchParameters, Branch } from 'ep-bt-field-agent-proxy';
import { Router, NavigationExtras } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { PagingParameters, SortParameters, SortParametersDirection } from 'ep-bt-field-agent-proxy';
import { EpDataViewModelService,  EpEventService } from '@epicor/kinetic';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'product-purchased-by-grid',
  templateUrl: './epbt-fa-product-purchased-by-grid.component.html',
  styleUrls: ['./epbt-fa-product-purchased-by-grid.component.scss']
})

export class EpbtFaProductPurchasedByGridComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;

  productsCode: any;
  data: any;
  productId: number;
  productDetails: any;
  productCode: any;
  productspurchased: any;
  @Output() loadingChange = new EventEmitter<boolean>();
  @ViewChild(EpGridComponent, { static: false }) grid: EpGridComponent;
  @ViewChild('dateTemplate', { static: false }) dateTemplate: TemplateRef<any>;
  @ViewChild('sellPriceTemplate', { static: true }) sellPriceTemplate: TemplateRef<any>;

  showGrid = true;
  public gridModel: IEpGridModel;
  public pageSize = 10;
  public cards: Array<IEpBtCardControlModel>;

  webTrackUser: any;
  productPurchasedbyRequest: GetProductPurchasesByAllCustomersRequest;
  paging: PagingParameters;
  sort: SortParameters;
  webtrackResult: any;
  currency: string;
  bisTrackSettings: any;

  totalPages = 1;
  pageArray: Array<number> = [];
  lastPage: number;
  lastRecords: any;
  mobileData: any;
  isLastRecords = false;
  isMoreEnable = false;
  purchasedProductsCollection: any = [];

  constructor(private client: FieldAgentClient, private route: ActivatedRoute, private router: Router,
    private fieldAgentService: EpbtFieldAgentService, private config: BistrackConfig,
    private productService: EpbtFaProductService, public quickOrderService: EpbtFaQuickOrderService, public epEvent: EpEventService) { }

  ngOnInit() {
    // this.productDetails = EpDataViewModelService.current.item("selectedProductItem").data[0];
    this.productDetails = this.productService.selectedProductItem;
    // var bistrackSettings = this.fieldAgentService.getBisTrackSetting();
    // this.currency = bistrackSettings.baseCurrency.symbol;
    // this.pageSize= bistrackSettings.searchPageSize;

    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.currency = bistrackSettings.baseCurrency.symbol;
      this.pageSize = bistrackSettings.searchPageSize;
    });

    // this.webTrackUser = this.fieldAgentService.getWebTrackUser();
    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.gridModel = this.getGridModel([]);
    });
    // this.gridModel = this.getGridModel();
    // this.getGridData();

  }


  // grid model start
  getGridModel(productpurchasedList): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'OrderNumber',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: false,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      data: productpurchasedList,
      columns: [
        { field: 'productDescription', title: 'PRODUCT DESCRIPTION', width: 100, hidden: false },
        { field: 'productCode', title: 'PRODUCT CODE', width: 80, hidden: false },
        { field: 'customer.customerCode', title: 'CUST.CODE', width: 80, hidden: false },
        { field: 'customer.name', title: 'CUST.NAME', width: 80, hidden: false },
        { field: 'orderNumber', title: 'ORDER NUMBER', width: 60, hidden: false },
        { field: 'orderDate', title: 'ORDER DATE', width: 80, hidden: false, cellTemplate: this.dateTemplate },
        { field: 'price', title: 'SELL PRICE', width: 60, hidden: false, cellTemplate: this.sellPriceTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.navigateToProductDetailsView(eventArg.event.dataItem);
        }
      },
      loader: (epGrid: EpGridComponent, state: IEpGridState) => {
        const observerResult = this.getGridModelData(epGrid, state, productpurchasedList, false);
        return observerResult;
      }
    };
    return model;
  }
  // grid model end

  // grid height calculation start
  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else { return 440; }// return 500;
  }
  // grid height calculation end
  // api call start

  // getGridData() {
  //   this.productPurchasedbyRequest = new GetProductPurchasesByAllCustomersRequest();
  //   this.productPurchasedbyRequest.currentUser = this.webTrackUser;

  //   // this.productPurchasedbyRequest.pagingParameters = new PagingParameters();
  //   // this.productPurchasedbyRequest.pagingParameters.index = 0;
  //   // this.productPurchasedbyRequest.pagingParameters.count = this.pageSize;

  //   this.productPurchasedbyRequest.sortParameters = new SortParameters();
  //   this.productPurchasedbyRequest.sortParameters.sortColumn = "OrderNumber";
  //   this.productPurchasedbyRequest.sortParameters.direction = SortParametersDirection.Descending;

  //   var bar = new Date().getFullYear() - 100;
  //   var oneYearLater = new Date();
  //   oneYearLater.setFullYear(bar);

  //   this.productPurchasedbyRequest.searchParameters = new CustomerProductPurchaseSearchParameters();
  //   this.productPurchasedbyRequest.searchParameters.branch = new Branch();
  //   this.productPurchasedbyRequest.searchParameters.branch.branchID = this.webTrackUser.bisTrackBranch.branchID;
  //   this.productPurchasedbyRequest.searchParameters.startDate = oneYearLater;
  //   this.productPurchasedbyRequest.searchParameters.endDate = new Date();
  //   this.productPurchasedbyRequest.searchParameters.productSearchString = this.productDetails.productCode;
  //   this.productPurchasedbyRequest.searchParameters.jobRefSearchString = "";

  //   this.client.getProductPurchasesByAllCustomers(this.productPurchasedbyRequest).subscribe(res => {

  //     this.productspurchased = res.lines;
  //     this.gridModel.data = this.productspurchased;
  //     // console.log(this.productspurchased.length)

  //   });
  // }


  getGridModelData(epGrid: EpGridComponent, state: IEpGridState, productpurchasedList, isMobile: boolean): Observable<IEPGridDataResult> {
    const observerResult = new Observable<IEPGridDataResult>(observer => {
      const index = state.skip + state.take;
      const pageNumber = Math.ceil(index / state.take);
      const pageIndex = this.pageArray.indexOf(pageNumber);
      if ((pageIndex >= 0 && !isMobile) || (pageNumber == this.lastPage && this.lastRecords && this.lastRecords.length > 0 && !isMobile)) {
        epGrid.model.loadingIndicator = false;
        const showoff = pageNumber == this.lastPage ? this.lastRecords : this.purchasedProductsCollection.slice(state.take * pageIndex, (state.take * pageIndex) + state.take);
        const result: IEPGridDataResult = {
          data: showoff,
          total: this.totalPages
        };
        observer.next(result);
        observer.complete();
      } else {
        if (!isMobile) {
          epGrid.model.loadingIndicator = true;
        }
        this.productPurchasedbyRequest = new GetProductPurchasesByAllCustomersRequest();
        this.productPurchasedbyRequest.currentUser = this.webTrackUser;

        this.paging = new PagingParameters();
        this.paging.index = state.skip;
        this.paging.count = this.pageSize;
        this.productPurchasedbyRequest.pagingParameters = this.paging;

        this.sort = new SortParameters();
        this.sort.sortColumn = 'OrderNumber';
        this.sort.direction = SortParametersDirection.Descending;
        this.productPurchasedbyRequest.sortParameters = this.sort;

        const bar = new Date().getFullYear() - 100;
        const oneYearLater = new Date();
        oneYearLater.setFullYear(bar);

        this.productPurchasedbyRequest.searchParameters = new CustomerProductPurchaseSearchParameters();
        this.productPurchasedbyRequest.searchParameters.branch = new Branch();
        this.productPurchasedbyRequest.searchParameters.branch.branchID = this.webTrackUser.bisTrackBranch.branchID;
        this.productPurchasedbyRequest.searchParameters.startDate = oneYearLater;
        this.productPurchasedbyRequest.searchParameters.endDate = new Date();
        this.productPurchasedbyRequest.searchParameters.productSearchString = this.productDetails.productCode;
        this.productPurchasedbyRequest.searchParameters.jobRefSearchString = '';

        // this.productPurchasedbyRequest.searchParameters = customerProductPurchaseSearchParameter;
        this.client.getProductPurchasesByAllCustomers(this.productPurchasedbyRequest).subscribe(res => {
          productpurchasedList = res.lines;
          if (productpurchasedList != null && productpurchasedList != undefined && productpurchasedList.length > 0) {
            this.totalPages = res.resultCount;
            this.lastPage = Math.ceil(this.totalPages / state.take);
            if (pageNumber != this.lastPage) {
              this.pageArray.push(pageNumber);
            }

            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            if (productpurchasedList.length < state.take) {
              this.lastRecords = productpurchasedList;
            } else {
              this.purchasedProductsCollection = [...this.purchasedProductsCollection, ...productpurchasedList];
            }
            if (!isMobile) {
              this.mobileData = this.purchasedProductsCollection;
              if (this.lastRecords && this.lastRecords.length > 0) {
                this.mobileData = [...this.mobileData, ...this.lastRecords];
              }
              this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
            }

            length = this.purchasedProductsCollection.length;
            const result: IEPGridDataResult = {
              data: productpurchasedList,
              total: this.totalPages
            };
            observer.next(result);
            observer.complete();
          } else {
            const result: IEPGridDataResult = {
              data: [],
              total: 0
            };
            observer.next(result);
            observer.complete();
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            this.isMoreEnable = false;
            this.mobileData = this.mobileData ? this.mobileData : [];
          }
        });
      }
      this.loadingChange.emit(false);
    });
    return observerResult;
  }

  getMobileData() {
    const take = this.pageSize;
    for (let i = 1; i <= this.lastPage; i++) {
      const index = this.pageArray.indexOf(i);
      if (index == -1) {
        const state: IEpGridState = {
          skip: (i - 1) * take,
          take: take
        };
        let epGrid: EpGridComponent;
        this.getGridModelData(epGrid, state, [], true).subscribe(res => {
          if (res.data && res.data.length > 0) {
            let j = 0;
            if (res.data.length == state.take) {
              res.data.forEach(element => {
                this.mobileData.splice((state.take * (i - 1)) + j, 0, element);
                j++;
              });
            }
            if (this.lastRecords && this.lastRecords.length > 0 && !this.isLastRecords) {
              this.mobileData = [...this.mobileData, ...this.lastRecords];
              this.isLastRecords = true;
            }
            this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
          }
        });
        break;
      }
    }
  }

  // api call end

  navigateToProductDetailsView(args) {
    if (this.quickOrderService.isNewOrder) {
      EpDataViewModelService.current.add('selectedItem', [args]);
      this.epEvent.broadcast(CustomEvents.NewQuickorderSelectedProductDetails);

    } else {
      EpDataViewModelService.current.add('selectedItem', [args]);
      this.router.navigate(['/home/documents/details', args.orderId]);
    }



  }

  onCardClick(model) {

    this.navigateToProductDetailsView(model);
  }

  SetAutomaticDateRange(daterange) {
    if (daterange == CustomerProductPurchaseSearchDateRange.Last30Days) {

      // var date = new date().getDate - 30;

      // var bar = new Date().getDate() - 100;

      // var oneYearLater = new Date();
      // oneYearLater.setFullYear(bar);
    } else if (daterange == CustomerProductPurchaseSearchDateRange.CurrentMonth) {

    } else if (daterange == CustomerProductPurchaseSearchDateRange.Last2Months) {

    } else if (daterange == CustomerProductPurchaseSearchDateRange.Last3Months) {

    } else if (daterange == CustomerProductPurchaseSearchDateRange.Last6Months) {

    } else if (daterange == CustomerProductPurchaseSearchDateRange.Last12Months) {

    }

  }

}
